import TableFilter from '@/components/common/tablefilter/TableFilter.vue'

export default {
  name: 'ReportNotify',
  data () {
    return {
      filterValues: {
        reportSubCode: [],
        fromDatePeriod: null,
        toDatePeriod: null,
        clientName: '',
        clientClassificationGroups: [],
        clientManagers: [],
        clientStatuses: [],
        clientOnlyMine: [],
        reportStatuses: ['EMPTY']
      },
      currentReq: null,
      loading: false,
      items: [],
      updating: false
    }
  },
  components: {
    TableFilter
  },
  computed: {
    getTitle () {
      return this.$t('menu.reports.notify.title');
    },
    tableFilterConfig () {
      const filters = { };
      filters.reportSubCode = { type: 'checkbox', label: this.$t('client.filters.reportSubCode'), options: this.reportNameOptions };
      filters.reportStatuses = { type: 'checkbox', colFilterType: 'select', label: this.$t('report.status'), options: this.reportStatusOptions, class: 'col-sm-2' };
      filters.fromDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from'), class: 'col-md-2' }
      filters.toDatePeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to'), class: 'col-md-2' }
      filters.clientName = { type: 'text', label: this.$t('client.name'), class: 'col-md-2' };
      filters.clientClassificationGroups = { type: 'checkbox', label: this.$t('client.category'), options: this.clientClassificationGroupOptions };
      filters.clientManagers = { type: 'checkbox', label: this.$t('client.manager'), options: this.managerOptions, valueField: 'api_id' };
      filters.clientStatuses = { type: 'checkbox', label: this.$t('client.status.title'), options: this.clientStatusOptions, class: 'col-md-2' };
      filters.clientOnlyMine = { type: 'checkbox', label: ' ', options: this.onlyMineOptions, class: 'col-md-2' };
      return filters;
    },
    clientClassificationGroupOptions () {
      return this.ZPFormatHelper.getClassificationGroupFilterOptions();
    },
    clientStatusOptions () {
      return [
        { code: 0, text: this.$t('client.status.active') },
        { code: 1, text: this.$t('client.status.blocked') }
      ]
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, false);
    },
    managerOptions () {
      return this.$store.getters.getConfigOptions('managers');
    },
    reportStatusOptions () {
      return this.$store.getters.getConfigOptions(
        'client_report_statuses',
        this.$i18n.locale,
        'code',
        ['EMPTY', 'REJECTED'],
        false,
        false,
        true
      );
    },
    onlyMineOptions () {
      return [
        { code: 1, text: this.$t('client.onlyMine') }
      ];
    },
    tableHeaders () {
      const headers = [
        { key: 'name', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'api_id' }, filterKey: 'clientName', sortable: true },
        { key: 'primary_filler_email', label: this.$t('client.primary_filler_user'), type: 'slot', slotcode: 'email' },
        { key: 'reports.length', label: this.$t('report.count'), sortable: true },
        { key: 'last_notified_at', label: this.$t('report.lastNotifiedAt'), type: 'datetime', sortable: true },
        { key: 'checked', label: '', type: 'slot', slotcode: 'checkbox' }
      ];
      return headers;
    },
    tableExpandHeaders () {
      const headers = [
        { key: 'summary', label: '', format: 'formatReportModificationIcons', class: 'text-right' },
        { key: 'report_config_id', label: this.$t('report.title'), type: 'slot', slotcode: 'reporturl' },
        { key: 'date_period_id', label: this.$t('general.datePeriod.title'), format: 'formatDatePeriod' },
        { key: 'updated_at', label: this.$t('general.updated_at'), type: 'datetime' },
        { key: 'status_id', label: this.$t('report.status'), format: 'formatFromConfig', configKey: 'client_report_statuses', configParam: 'name' },
        { key: 'summary.total', label: this.$t('general.total'), format: 'formatMeasureTypeValues' },
        { key: 'summary.cost', label: this.$t('general.currency'), format: 'formatDecimal', precision: 2 },
        { key: 'notifiedAt', label: this.$t('report.notifiedAt'), type: 'datetime' },
        { key: 'notifyCount', label: this.$t('report.notifyCount') }
      ];
      return headers;
    }
  },
  methods: {
    show (activeFilters) {
      const skipFilterImport = ['reportStatuses'];
      Object.keys(activeFilters).forEach(key => {
        if (!skipFilterImport.includes(key) && Object.prototype.hasOwnProperty.call(this.filterValues, key)) {
          this.filterValues[key] = activeFilters[key];
        }
      });
      this.getTableData();
      this.$refs['modal-window'].show();
    },
    close () {
      this.$refs['modal-window'].hide();
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.$forceUpdate();
      let filterValues = this.BasicHelper.cloneObject(this.filterValues);
      if (this.$refs.billstable) {
        filterValues = this.$refs.billstable.getFilterValues();
        this.BasicHelper.updateFilterValues(this.$route.name, filterValues);
      }
      const self = this;
      this.currentReq = this.ApiRequest.request('report/empty/grouped', this.ApiRequest.REQUEST_POST, filterValues, function (response) {
        if (response.data) {
          self.items = response.data;
          self.loading = false;
        }
      })
    },
    checkallItems (val) {
      if (this.items) {
        Object.keys(this.items).forEach(key => {
          this.items[key].checked = val;
        });
      }
      this.$forceUpdate();
    },
    generateNotifications (approved = false) {
      const clientIds = this.items.filter(el => el.checked).map(el => el.id);
      if (approved && clientIds.length > 0 && !this.updating) {
        this.updating = true;
        const self = this;
        const reqData = {
          clients: clientIds,
          reportStatuses: this.filterValues.reportStatuses,
          fromDatePeriod: this.filterValues.fromDatePeriod,
          toDatePeriod: this.filterValues.toDatePeriod,
          reportSubCode: this.filterValues.reportSubCode
        }
        this.ApiRequest.request('report/empty/notify', this.ApiRequest.REQUEST_POST, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.updating = false;
        })
      } else if (!this.updating) {
        this.$refs.sendNotificationsApprove.show(null, this.$t('menu.reports.notify.title'), this.$t('menu.reports.notify.send-message', { total: clientIds.length }))
      }
    },
    openReport (item, newtab = 0) {
      const client = this.items.find(el => el.id == item.client_id);
      const reportCode = this.$store.getters.getParamFromConfigByFilter('report_configs', 'id', item.report_config_id, 'code');
      if (client && reportCode) {
        const params = { clientApiId: client.api_id, reportCode: reportCode, datePeriodCode: item.date_period_id }
        this.BasicHelper.openRouteUrl('menu.client.report', params, null, newtab);
      }
    }
  }
}
